import { lazy } from 'react'
import PayRunsLoader from './pay-runs/loader'
import EditPayRunLoader from './pay-runs/edit/loader'

export default {
  PayRuns: {
    Component: lazy(() => import('./pay-runs/PayRuns.Page')),
    Loader: PayRunsLoader,

    Edit: {
      Component: lazy(() => import('./pay-runs/edit/EditPayRun.Page')),
      Loader: EditPayRunLoader,
    },
  },
}
